<template>
  <span>
    <b-row class="justify-content-md-center my-4">
      Cliquez sur une ligne du tableau pour personnaliser le message
    </b-row>

    <b-table
      :fields="tableColumns"
      :items="tableData"
      class="pointer-table"
      stacked="md"
      striped
      @row-clicked="(item) => $set(item, '_showDetails', !item._showDetails)"
    >
      <template v-slot:row-details="row">
        <text-editor
          v-model="row.item.messagePerso"
          :name="'texteditor' + row.index"
        ></text-editor>
      </template>
    </b-table>
  </span>
</template>
<script>
import TextEditor from "../TextEditor";

export default {
  props: { tableData: { type: Array, required: false } },
  components: {
    TextEditor: TextEditor,
  },
  data() {
    return {
      newText: "",
      tableColumns: [
        {
          key: "nom",
          label: "Nom",
          sortable: true,
        },
        {
          key: "prenom",
          label: "Prénom",
          sortable: true,
        },
        {
          key: "adresse",
          label: "Adresse",
          sortable: true,
        },
        {
          key: "montant",
          label: "Montant",
          sortable: true,
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
        },
        {
          key: "dateDon",
          label: "Date don",
          sortable: false,
        },
        {
          key: "modePaiement",
          label: "Mode paiement",
          sortable: false,
        },
      ],
    };
  },

  watch: {
    tableData(val) {
      this.$emit("change", val);
    },
  },
  methods: {
    showRowDetail(row) {
      row._showDetails = !row._showDetails;
    },
  },
};
</script>
